// GET DB 조회 함수
export function GetDBInfo(templateId) {
    return fetch(`/api_DBInsert/${templateId}`, {
        method: 'GET',
    })
    .then(response => {
        // HTTP 상태 체크
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Content-Type 확인
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            throw new Error('서버에서 JSON이 아닌 응답을 받았습니다.');
        }
        
        return response.json();
    })
    .catch(error => {
        console.error('오류:', error);
        throw error; // 오류를 던짐
    });
}


// POST DB 데이터 전송 함수
export function insertIntoDB(data) {
    return fetch('/api_DBInsert', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        },
        body: JSON.stringify(data)
    });
}
